module.exports = __webpack_public_path__ + "static/media/Tyrrells-180x180.cd471f7c.png";